import React, { useState } from 'react';
import {
  FDClickableText,
  FDStack,
  FDTableCell,
  FDTableRow,
  FDTableRowGroup,
  FDTableRowGroupBody,
  FDTableRowGroupHead,
} from '@facet-wealth/design';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import { USDCurrencyFullFormatter } from 'Helpers/Formats';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import useManagedAccountPageEventLogger
  from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/managedAccountPage.eventLogging';

const ManagedAccountTableRowGroup = ({ holdingsGroup, categoryIDToCategoryMap }) => {
  const { logHoldingsTable } = useManagedAccountPageEventLogger();

  const [expanded, setExpanded] = useState(false);
  const { holdings } = holdingsGroup;

  return (
    <FDTableRowGroup expanded={expanded}>
      <FDTableRowGroupHead hover onClick={() => setExpanded(!expanded)}>
        <FDTableCell align={'left'}>
          <FDClickableText appearance={'standalone'} label={holdingsGroup.name} />
        </FDTableCell>
        <FDTableCell align={'center'}>{'--'}</FDTableCell>
        <FDTableCell align={'center'}>{'--'}</FDTableCell>
        <FDTableCell align={'right'}>{holdingsGroup.total}</FDTableCell>
        <FDTableCell align={'center'}>{'--'}</FDTableCell>
        <FDTableCell align={'center'}>{'--'}</FDTableCell>
      </FDTableRowGroupHead>
      <FDTableRowGroupBody>
        {holdings.map((holding) => {
          const category = categoryIDToCategoryMap.get(holding.attr('tickerClassification'));
          return (
            <FDTableRow key={holding.id()} hover>
              <FDTableCell>
                <FDStack direction={'row'} alignItems={'center'}>
                  {category ? <FiberManualRecordIcon
                    style={{ color: category.color }}
                    onClick={() => logHoldingsTable(`Color icon for category ${category.label}`)}
                  /> : null}
                  {holding.attr('ticker')}
                </FDStack>
              </FDTableCell>
              <FDTableCell align={'right'}>{holding.attr('quantity')}</FDTableCell>
              <FDTableCell align={'right'}>{USDCurrencyFullFormatter.format(holding.attr('currentPrice'))}</FDTableCell>
              <FDTableCell align={'right'}>{USDCurrencyFullFormatter.format(holding.attr('currentValue'))}</FDTableCell>
              <FDTableCell align={'right'}>{USDCurrencyFullFormatter.format(holding.attr('costBasis'))}</FDTableCell>
              <FDTableCell align={'right'}>{USDCurrencyFullFormatter.format(holding.attr('dollarGain'))}</FDTableCell>
            </FDTableRow>
          );
        })}
      </FDTableRowGroupBody>
    </FDTableRowGroup>
  );
};

ManagedAccountTableRowGroup.defaultProps = {};
ManagedAccountTableRowGroup.propTypes = {
  holdingsGroup: PropTypes.instanceOf(fr.Resource).isRequired,
  categoryIDToCategoryMap: PropTypes.instanceOf(Map).isRequired,
};

export { ManagedAccountTableRowGroup };
